import styled from 'styled-components';
import Link from '@nubank/nuds-web/components/Link/Link';

export const StyledLink = styled(Link)`
  text-decoration: underline;
  color: black;
`;
StyledLink.displayName = 'StyledLink';
